import { render } from "./DepartmentMenuNew.vue?vue&type=template&id=1f4d962c&ts=true"
import script from "./DepartmentMenuNew.vue?vue&type=script&lang=tsx"
export * from "./DepartmentMenuNew.vue?vue&type=script&lang=tsx"

import "./DepartmentMenuNew.vue?vue&type=style&index=0&id=1f4d962c&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__